import financialApi from 'api/requests/financial'
import Loader from 'components/_UI/Loader';
import Paginate from 'components/_UI/Paginate';
import Table from 'components/_UI/Table';
import Text from 'components/_UI/Text'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import React, { useEffect, useState } from 'react'
import { Activity } from 'react-feather';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import FinancialStatusIcon from '../status/FinancialStatusIcon';
import { Row } from 'styled/alignment/Row';
import currency from 'helpers/currency';

export default function TransactionsList() {
    const [content, setContent] = useState(null);
    const [paginate, setPaginate] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getTransactions();
    }, [])

    const transactionTypes = {
        withdraw: 'withdraw',
        refund: 'refund',
        sell: 'sell'
    }

    async function getTransactions(number = 1) {
        setLoading(true);
        try {
            const { data } = await financialApi.getStatementBalance({ page: number })
            setContent(data?.data)
            setPaginate(data)
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const transactionsData = content?.map(item => {
        const date = new Date(item.created_at);
        return {
            description:
                <Row style={{ alignItems: 'center' }}>
                    <FinancialStatusIcon status={item?.category} />
                    <Column>
                        <Text paddingBottom={0} color={colors.nightDark}>
                            {item.description}
                        </Text>
                        <Text name='small' color={colors.night}>
                            {date.toLocaleDateString('pt-BR')} - {date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                        </Text>
                    </Column>
                </Row>,
            type:
                <TypeBadge category={item.category}>
                    {item.category === transactionTypes.sell && 'Receita'}
                    {item.category === transactionTypes.withdraw && 'Saque'}
                    {item.category === transactionTypes.refund && 'Estorno'}
                </TypeBadge>,
            gross_value: <>
                {
                    item?.category === transactionTypes.refund || item?.category === transactionTypes.withdraw
                        ? <Text color={colors.danger} paddingBottom={0}>-{currency.format(item.gross_value)}</Text>
                        : <Text color={colors.success} paddingBottom={0}>{currency.format(item.gross_value)}</Text>
                }
            </>,
            tax_value: <Text paddingBottom={0}>{currency.format(item.tax_value)}</Text>,
            liquid_value: `R$ ${parseFloat(item.liquid_value).toFixed(2).replace('.', ',')}`,
            status: <StatusBadge status='success'>
                Processado
            </StatusBadge>,
        };
    });

    return (
        <Container>
            {loading ? <Loader /> : (
                content?.length > 0 ? (
                    <>
                        <SectionHeader>
                            <SectionIcon>
                                <Activity size={18} color={colors.occasionalPurple} />
                            </SectionIcon>
                            <HeaderContent>
                                <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                                    Transações recentes
                                </Text>
                                <Text name='small' color={colors.night} paddingBottom={0}>
                                    Histórico completo de movimentações
                                </Text>
                            </HeaderContent>
                        </SectionHeader>
                        <Table
                            rows={transactionsData}
                            columns={['Descrição', 'Tipo', 'Valor bruto', 'Taxa', 'Valor líquido', 'Status']}
                        />
                        {paginate?.last_page > 1 && (
                            <Paginate
                                onPaginate={number => getTransactions(number)}
                                perPage={paginate?.perPage}
                                totalItems={paginate?.totalItems}
                                lastPage={paginate?.lastPage}
                                firstPage={1}
                                currentPage={paginate?.currentPage}
                                marginTop={'30px'}
                            />
                        )}
                    </>
                ) : (
                    <NotResultDashBoard
                        text={
                            <>
                                <Text name='subtitle'>Transações recentes</Text>
                                <Text>Parece que você ainda não possui transações recentes.</Text>
                                <Text>Que tal criar um evento e começar a faturar?</Text>
                            </>
                        }
                        ilustration={'transactions'}
                        marginTop={'15px'}
                    />
                )
            )}
        </Container>
    )
}

const Container = styled(Column)`
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    padding: 20px;
    margin-top: 10px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    font-size: ${fonts.sizes.mini};
    font-weight: 600;
    border-radius: 50px;
    letter-spacing: 0.2px;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
    `};

    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
    `};
`;

const TypeBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    font-size: ${fonts.sizes.mini};
    font-weight: 600;
    border-radius: 50px;
    letter-spacing: 0.2px;

    ${({ category }) => category === 'sell' && `
        background: ${colors.success}12;
        color: ${colors.successDark};
    `};

    ${({ category }) => category === 'withdraw' && `
        background: ${colors.primary}12;
        color: ${colors.primary};
    `};

    ${({ category }) => category === 'refund' && `
        background: ${colors.danger}12;
        color: ${colors.danger};
    `};
`;
